import router from '../../routs/router';
import { store } from "../index";

export default {
    state: () => ({
        data: { }
    }),
    mutations: {
        ['product/setState'](state, payload) {
            state.data = payload;
        },
        ['product/changeComments'](state, { items, pagination, routes }) {
            state.data.product.comments = {
                ...state.data.product.comments,
                items,
                pagination,
                routes,
            }
        },
        ['product/addMoreComments'](state, { items, pagination, routes }) {
            state.data.product.comments = {
                items: [...state.data.product.comments.items, ...items ],
                pagination,
                routes,
            }
        },
        ['product/changeSizeTab'](state, payload) {
            state.data.product.sizesTable = state.data.product.sizesTable.map(el => {
                return {
                    ...el,
                    active: el.id === payload,
                }
            })
            // console.log(state, payload);
        }
    },
    actions: {
        async ['product/getPageData'] ({ commit }, { url, changeUrl }) {
            try {
                commit('global/loaderStart');

                const { data, status } = await axios.get(url, { params: { api: 'y' } });

                if (status !== 200) {
                    throw `bad request response ${ payload }?api=y \n status: ${ status }`;
                }

                // if (data.breadcrumbs) {
                //     store.commit('store/setResultsStore', { name: 'breadcrumbs', value: data.breadcrumbs });
                // }
                if (data.stores) {
                    store.commit('stores/setState', data.stores);
                }
                commit('product/setState', data);

                if (changeUrl) {
                    router.replace(url);
                }



                return true;
            } catch (err) {
                console.error(err);
            } finally {
                commit('global/loaderStop');
            }
        },
        async ['product/addComment'] ({ commit, state }, payload) {
            try {
                const { action, path } = state.data.product.comments.routes.setComment;
                let formData = payload;

                if (action && path) {
                    formData.append('action', action);
                    formData.append('hidePageKey', 'Y');
                    const { status, data } = await axios.post(path, formData);

                    if (status !== 200) {
                        throw `bad request response status: ${ status } \n url: ${ path }`;
                    }

                    commit('product/changeComments', data);
                    return true;
                } else {
                    throw `action: ${ action } or path: ${ path } is empty`;
                }

            } catch (err) {
                console.error(err);
            }
        },
        // async ['product/addSubComment'] ({ commit, state }, payload) {
        //     try {
        //         const { action, path } = state.data.product.comments.routes.setComment;
        //         let formData = payload;
        //
        //         if (action && path) {
        //             formData.append('action', action);
        //             const { status, data } = await axios.post(path, formData);
        //
        //             if (status !== 200) {
        //                 throw `bad request response status: ${ status } \n url: ${ path }`;
        //             }
        //
        //             commit('product/changeComments', data);
        //             return true;
        //         } else {
        //             throw `action: ${ action } or path: ${ path } is empty`;
        //         }
        //
        //     } catch (err) {
        //         console.error(err);
        //     }
        // },
        async ['product/changePagination'] ({ commit, state, getters }, payload) {
            try {
                const { path, action } = state.data.product.comments.routes.getComments;
                const id = getters['product/id'];
                const { page } = payload;

                const { status, data } = await axios.get(path, {
                    params: {
                        id,
                        action,
                        page,
                        hidePageKey : 'Y'
                    }
                });

                if (status !== 200) {
                    throw `bad request response status: ${ status } \n url: ${ path }`;
                }

                commit('product/changeComments', data);
            } catch (err) {
                console.error(err);
            }
        },
        async ['product/addMorePagination'] ({ commit, state, getters }) {
            try {
                const { path, action } = state.data.product.comments.routes.getComments;
                const { pageNumber } = state.data.product.comments.pagination;
                const id = getters['product/id'];

                const { status, data } = await axios.get(path, {
                    params: {
                        page: +pageNumber + 1,
                        id,
                        action,
                        hidePageKey : 'Y'
                    }
                });
                if (status !== 200) {
                    throw `bad request response status: ${ status } \n url: ${ path }`;
                }

                commit('product/addMoreComments', data);
            } catch (err) {
                console.error(err);
            }
        },
    },
    getters: {
        ['product/id']: ({ data: { product } }) => {
            return product?.offer?.id || product?.id;
        },
        ['product/activeSize']: ({ data: { product } }) => {
            const SIZES = product?.skuMatrix?.SIZES?.items;

            if (SIZES) {
                return SIZES?.find(el => el.active);
            }
        },
        ['product/isAvailable']: state => payload => {
            let product = payload ?? state?.data?.product;
            if (product?.offer) return product?.offer?.isAvailable;
            else return product?.isAvailable;
        },
    }
}